import React from 'react';

import { Icon, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { ILocation } from '@rbi-ctg/frontend';
import Link, { ILinkProps } from 'components/link';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';
import { nativeMapsHref } from 'utils/native-actions';

import theme from '../theme';

const DirectionsLinkStyled = Link.withConfig({
  color: theme.innerAnchorColor,
  fontSize: primitive.fontSizes.sm,
  isUnderlined: true,
});

type Props = Omit<ILinkProps, 'to' | 'isInline'> & {
  activeCoordinates: ILocation | null;
  mapPosition: ILocation;
};

export const DirectionsLink = makeUclComponent(
  ({ activeCoordinates, mapPosition, ...rest }: Props) => {
    return (
      <View style={styles.container}>
        <DirectionsLinkStyled
          {...rest}
          isInline={false}
          isExternal
          to={nativeMapsHref(activeCoordinates, mapPosition)}
        >
          {t('directions')}
        </DirectionsLinkStyled>
        <Icon
          color={theme.innerAnchorColor}
          variant="openInNew"
          size="$3_5"
          style={styles.icon}
          {...hiddenAccessibilityPlatformProps}
        />
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  icon: {
    marginLeft: 4,
    transform: [{ translateY: 1 }],
  },
});
